import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { AdminReviewerBookResponse } from '../../responses/platform/admin-reviewer-book.response';
import { AdminReviewerBookRequest } from '../../requests/platform/admin-reviewer-book.request';

@Injectable({
  providedIn: 'root'
})
export class AdminReviewerBookService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public postAdminReviewerBook(request: AdminReviewerBookRequest): Observable<AdminReviewerBookResponse> {
    return this.http
      .post<AdminReviewerBookResponse>(environment.urlApiPlatform + 'AdminReviewerBook',request,this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}